import "./ViewerModeButtonComponent.css";
import { useTranslation } from "react-i18next";
import { emitter } from "../../input/AppEvents";
import { ViewerModeEnum } from "../../store/viewerState/ViewerMode/ViewerMode";
import { useViewerStateStore } from "../../store/viewerStateStore";

interface ViewerModeButtonComponentProps {
    mode: ViewerModeEnum
    nameResourceKey: string;
}

const ViewerModeButtonComponent = (props : ViewerModeButtonComponentProps) => {

    const currentMode = useViewerStateStore((state) => state.viewerMode); // Subscribe to mode changes so the component re-renders when mode changes
    const { t } = useTranslation();
    const { mode, nameResourceKey } = props;

    let className = "viewer-mode-button";

    if (currentMode && currentMode.modeEnum === mode) {
        className += " viewer-mode-button-active";
    }

    return (
        <button className={className} onClick={() => emitter.emit("viewerModeChange", mode) }>
            {t(nameResourceKey)}
        </button>

    )

};

export default ViewerModeButtonComponent;